export default __webpack_public_path__ + "static/media/AND-401.b94b1a3a.jpg";